import { createSlice } from "@reduxjs/toolkit";
import { savePacking, fetchPackingList } from "./packingThunk";

const initialState = {
    sscc_code: "",
    parserManufacturer: null,
    qrCode: "",
    items: [], // [{ manufacture_id, manufacturer_name, gtin, serial_number, batch_name, batch_expiry, raw_qr_code }]
    saving: false,
    list: [],
    listLoading: false,
};

const packingSlice = createSlice({
    name: "tatmeenPacking",
    initialState,
    reducers: {
        setFormField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },
        addPackingItem(state, action) {
            state.items.push(action.payload);
        },
        removePackingItem(state, action) {
            state.items.splice(action.payload, 1);
        },
        resetPackingForm(state) {
            state.sscc_code = "";
            state.items = [];
            state.qrCode = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(savePacking.pending, (state) => {
                state.saving = true;
            })
            .addCase(savePacking.fulfilled, (state) => {
                state.saving = false;
            })
            .addCase(savePacking.rejected, (state) => {
                state.saving = false;
            })
            .addCase(fetchPackingList.pending, (state) => {
                state.listLoading = true;
            })
            .addCase(fetchPackingList.fulfilled, (state, action) => {
                state.listLoading = false;
                state.list = action.payload;
            })
            .addCase(fetchPackingList.rejected, (state) => {
                state.listLoading = false;
            });
    },
});

export const {
    setFormField,
    addPackingItem,
    removePackingItem,
    resetPackingForm,
} = packingSlice.actions;

export default packingSlice.reducer;
